import { Component, Input, OnInit } from '@angular/core';
import { SFNumberWidgetSchema, SFSchema } from '@delon/form';
import { IComponentDef } from '../../shared/interfaces';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-form-config',
  templateUrl: './form-config.component.html',
  styleUrls: ['./form-config.component.less']
})
export class FormConfigComponent {
  bordered;
  @Input() data: IComponentDef;

  mapBool(list, bool) {
    list.map(v => {
      v.bordered = bool;
      if (v.children.length) {
        this.mapBool(v.children, bool);
      }
    });
  }
  borderedChange(bool) {
    if (bool) {
      this.mapBool([this.data], true);
    } else {
      this.mapBool([this.data], false);
    }
  }
}
